import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import { Symbols } from '@/symbols';
let ProductResourceSpaceContentDetailService = class ProductResourceSpaceContentDetailService {
    constructor(operationCenterApi, i18n) {
        this.operationCenterApi = operationCenterApi;
        this.i18n = i18n;
    }
    async getResourceContentDetail(content_id) {
        const res = await this.operationCenterApi.getResourceSpaceContentDetail(content_id);
        this.detail = res;
        return res;
    }
    // 获取详情信息
    getResourceContentDetailInfo() {
        const { content_name, label, priority, status, product_line_name, resource_space_name } = this.detail.resource_space_content;
        return {
            content_name: {
                value: content_name,
                label: this.i18n.t('backoffice.productResourceSpace.contentName'),
            },
            label: {
                value: label,
                label: this.i18n.t('backoffice.productResourceSpace.label'),
            },
            priority: {
                value: priority,
                label: this.i18n.t('backoffice.common.order'),
            },
            status: {
                value: status,
                label: this.i18n.t('backoffice.productResourceSpace.status'),
            },
            product_line_name: {
                value: product_line_name,
                label: this.i18n.t('backoffice.productResourceSpace.productLineName'),
            },
            resource_space_name: {
                value: resource_space_name,
                label: this.i18n.t('backoffice.productResourceSpace.resourceSpaceName'),
            },
        };
    }
    // 获取product_line_id
    getResourceContentDetailProductLineId() {
        return this.detail.resource_space_content.product_line_id;
    }
    // 获取resource_space_id
    getResourceContentDetailResourceSpaceId() {
        return this.detail.resource_space_content.resource_space_id;
    }
    // 获取卡片信息
    getResourceContentDetailCard() {
        const img = this.detail.resource_space_content.image;
        const content = this.detail.resource_space_content.content;
        return {
            ...content,
            img,
        };
    }
    // 获取规则
    getResourceContentDetailRule() {
        return this.detail.rule;
    }
    // 获取历史记录
    async getResourceContentDetailHistories(params, resource_space_content_id) {
        return this.operationCenterApi.getResourceSpaceContentDetailHistory(params, resource_space_content_id);
    }
};
ProductResourceSpaceContentDetailService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OperationCenterApi)),
    __param(1, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object])
], ProductResourceSpaceContentDetailService);
export { ProductResourceSpaceContentDetailService };
